module.exports = __webpack_public_path__ + "static/media/onenote.7f0b5f9b.svg";